import { type HttpClient, query, segment } from '../http';

import {
  type CreateReportPayload,
  type DecideReportPayload,
  type ReportPage,
  type ReportStatus,
} from './reports.types';

/**
 * Telling us that something is wrong, and what becomes of it.
 *
 * Warning: two doors on one subject. Filing is a player's gesture; the queue
 * lives behind `AdminGuard` and an application session is refused on it.
 */
export function createReportsApi(http: HttpClient) {
  return {
    /**
     * Files a report.
     *
     * ⚠️ Answers nothing. The reporter learns neither what was decided nor
     * whether the account was already reported — telling them would turn the
     * queue into a scoreboard, and a report that "did nothing" into a reason
     * to file another.
     */
    create: (payload: CreateReportPayload) =>
      http.post<void>('/reports', payload),

    /**
     * One tab of the queue, and every tab's count.
     *
     * ⚠️ Pending come oldest first — a queue is read to find what has waited
     * longest — and answered ones newest first.
     */
    queue: (status?: ReportStatus) =>
      http.get<ReportPage>(`/admin/reports${query({ status })}`),

    /** Closes one report. Only a pending one can be closed. */
    decide: (id: string, payload: DecideReportPayload) =>
      http.patch<void>(`/admin/reports/${segment(id)}`, payload),
  };
}
